import React from 'react';
import PropTypes from 'prop-types';
import { themer } from '@spp/theme-provider';

const Url = ({ url: urlValue, title: { value: titleValue } = {}, theme }) => (
    <div className={theme.root}>
        <a className={theme.url} href={urlValue}>
            {titleValue}
        </a>
    </div>
);
Url.propTypes = {
    url: PropTypes.string.isRequired,
    title: PropTypes.shape({
        value: PropTypes.string,
    }).isRequired,
    theme: PropTypes.shape({
        url: PropTypes.string,
    }),
};

Url.defaultProps = {
    theme: {},
};

export default themer('@vg/ui-url')(Url);



/** WEBPACK FOOTER **
 ** ./src/local-components/Url.js
 **/